@if (active) {
  <div>
    <div>
      Active
      <app-patient-deactivate-button [patient]="patient" (patientDeactivated)="onPatientDeactivated($event)" />
    </div>
  </div>
}

@if (!active) {
  <div>
    <strong class="text-danger">Inactive ({{ patient.inactiveDate | date: 'MM/dd/yyyy' }})</strong>
  </div>
}
